import { useCallback, useEffect, useRef, useState } from "react";
import firebase from "firebase/app";
import "firebase/auth";

firebase.initializeApp({
  apiKey: "AIzaSyAqkdp_fzbvpePD0E4ZuscVUpsQyHGvWBo",
  authDomain: "blackbook-89200.firebaseapp.com",
  databaseURL: "https://blackbook-89200.firebaseio.com",
  projectId: "blackbook-89200",
  storageBucket: "blackbook-89200.appspot.com",
  messagingSenderId: "22263867937",
  appId: "1:22263867937:web:1324ab1297381c7a",
});

function onAuthStateChange(
  callback: any,
  setIsLoading: any,
  setToken: any,
  mounted: boolean
) {
  return firebase.auth().onAuthStateChanged((user) => {
    if (user) {
      callback({ loggedIn: true, email: user.email });
      firebase
        .auth()
        .currentUser.getIdToken()
        .then((token) => {
          if (!mounted) return null;
          setToken(token);
        });
    } else {
      callback({ loggedIn: false });
    }

    setIsLoading(false);
  });
}

function login(username: string, password: string) {
  return new Promise((resolve: any, reject) => {
    firebase
      .auth()
      .signInWithEmailAndPassword(username, password)
      .then(() => resolve())
      .catch((error) => reject(error));
  });
}

function logout() {
  firebase.auth().signOut();
}

function useAuth(): any {
  const [user, setUser] = useState({ loggedIn: false });
  const [isLoading, setIsLoading] = useState(true);
  const [token, setToken] = useState(true);
  const [error, setError] = useState("");
  const mounted = useRef(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChange(
      setUser,
      setIsLoading,
      setToken,
      mounted.current
    );
    return () => {
      unsubscribe();
      mounted.current = false;
    };
  }, []);

  const requestLogin = useCallback((username: string, password: string) => {
    if (mounted.current) {
      login(username, password).catch((error) => setError(error.code));
    }
  }, []);

  const requestLogout = useCallback(() => {
    if (mounted.current) {
      logout();
    }
  }, []);

  return {user, isLoading, error, requestLogin, requestLogout, token};
}

export default useAuth;
